var render = function render(){var _vm=this,_c=_vm._self._c;return _c('field-info',{attrs:{"type":_vm.fieldCode}})
}
var staticRenderFns = []

export { render, staticRenderFns }